import StockChart from "./StockChart.js";
import RadarChart from "./RadarChart.js";
import BubbleChart from "./BubbleChart.js";
import RangeSlider from "./RangeSlider.js";
import CartesianChart from "./CartesianChart.js";
import CartesianChart3D from "./CartesianChart3D.js";
const undefault = (m) => typeof m === "function" ? m : m.default;
const componentFactories = [
  undefault(StockChart),
  undefault(RadarChart),
  undefault(BubbleChart),
  undefault(RangeSlider),
  undefault(CartesianChart),
  undefault(CartesianChart3D)
];
export {
  componentFactories
};
//# sourceMappingURL=index.js.map
